
export const education = (c) => {
    return {
        id: c.id,
        name: c.name,
        svpb: c.svpb,
        institute: c.institute,
        year: c.year,
        completed: c.completed,
        document: c.document,
        documentName: (c.documentName == null) ? 'Kopie document...': c.documentName
    }
};

export const assignment = (c) => {
    return {
        id: c.id,
        title: c.title,
        description: c.description,
        professionalsQty: c.professionalsQty,
        contactDetails: c.contactDetails,
        address: c.address,
        postalCode: c.postalCode,
        city: c.city,
        dates: c.dates.map((d) => { return new assignmentDate(d) }),
        startTime: c.startTime,
        hours: (!!c.hours) ? c.hours : 0,
        skills: (c.skills == null) ? [] : c.skills,
        clientProfileImage: c.clientProfileImage,
        clientCompany: c.clientCompany,
        clientEmail: c.clientEmail,
        clientName: c.clientName,
        clientPhone: c.clientPhone,
        professionalEmail: c.professionalEmail,
        professionalName: c.professionalName,
        professionalPhone: c.professionalPhone,
        professionalProfileImage: c.professionalProfileImage,
        conditions: (c.conditions) ? c.conditions : false

        //assignmentUsers: (c.assignmentUsers == null) ? [] : c.assignmentUsers
    }
}

export const assignmentDate = (c) => {
    return {
        id: c.id,
        date: c.date,
        startTime: c.startTime,
        hours: c.hours,
        actualHours: (!!c.actualHours ||c.actualHours > 0) ? c.actualHours : 0,
        lockedHours: (!!c.actualHours || c.actualHours > 0) ? true : false,
        assignmentId: c.assignmentId,
        assignmentUsers: (c.assignmentUsers == null) ? [] : c.assignmentUsers.map((u) => { return new assignmentUser(u) })
    }
}

export const assignmentUser = (c) => {
    return {
        id: c.id,
        applicationUserId: c.applicationUserId,
        assignmentStatusId: c.assignmentStatusId,
        assignmentDateId: c.assignmentDateId,
        startTime: c.startTime,
        hours: c.hours,
        actualHours: c.actualHours,
        inviteDate: c.inviteDate,
        updateDate: c.updateDate,
        applicationUser: c.applicationUser,
        assignmentStatus: c.assignmentStatus,
        assignmentDate: c.assignmentDate,
        rates: (c.rates == null) ? [] : c.rates,
        lockedHours: (!!c.actualHours || c.actualHours > 0) ? true : false
    }
}


export const chatMessage = (c) => {
    return {
        id: c.id,
        message: c.message,
        from: c.from,
        to: c.to,
        read: typeof(c.read) == "string" ? new Date(c.read) : c.read,
        send: typeof(c.send) == "string" ? new Date(c.send) : c.send,
        isRead: c.isRead,
        isMe: c.isMe,
        assignmentId: c.assignmentId,
        toAll: c.toAll
    }
}

export const report = (c) => {
    return {
        id: c.id,
        reportType: (c.reportType) ? c.reportType : 'Dienstrapport',
        reportDate: c.reportDate,
        subject: c.subject,
        message: c.message,
        internalComments: c.internalComments,
        submitDate: c.submitDate,
        assignmentId: c.assignmentId,
        attachments: c.attachments ? c.attachments : [],
        locked: c.locked || false,
        rapporteur: c.rapporteur
    }
}

export const review = (c) => {
    return {
        id: c.id,
        publicReview: c.publicReview,
        privateReview: c.privateReview,
        date: c.date,
        rating: c.rating,
        assignmentId: c.assignmentId,
        fromId: c.fromId,
        toId: c.toId,
    }
}

export const document = (c) => {
    return {
        id: c.id,
        fileName: c.fileName,
        fileSize: c.fileSize,
        fileContentType: c.fileContentType,
        file: c.file,
        createDate: c.createDate
    }
}